import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "../../../features/contact";

export const Route = createFileRoute("/$lang/_layout/contact")({
  component: ContactPage,
});
